import { BasicHbFilter } from "../../../models/filters/basicHbFilter";
import { EntDirection } from "../../../models/handBooks/direction";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { Paths } from "../../../paths";

export const directionApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getDirectionList: builder.query<ResponseDataGet<EntDirection>, BasicHbFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.direction }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getDirectionById: builder.query<ResponseDataTest<EntDirection>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.direction }/${ id }`,
		method: 'GET'
	  })
	}),
	addDirection: builder.mutation<ResponseDataTest<EntDirection>, EntDirection>({
	  query: (body) => ({
		url: `${ Paths.handbooks.direction }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editDirection: builder.mutation<ResponseDataTest<EntDirection>, EntDirection>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.direction }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteDirection: builder.mutation<ResponseDataTest<EntDirection>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.direction }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddDirectionMutation,
  useEditDirectionMutation,
  useDeleteDirectionMutation,
  useLazyGetDirectionListQuery
} = directionApi;
